module.exports = __webpack_public_path__ + "img/H4.7b213dfa.png";